import React, { useEffect, useState } from 'react';

export const Multometro: React.FC = () => {
    const [needleRotation, setNeedleRotation] = useState(-60);

    useEffect(() => {
        const timer = setTimeout(() => {
            setNeedleRotation(48); // Corresponds to >95% success rate
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="flex justify-center my-6">
            <div className="font-sans w-full max-w-md rounded-lg shadow-2xl p-3 bg-vumeter-case border-2 border-black/20">
                <div className="bg-vumeter-face rounded-md p-6 relative aspect-video overflow-hidden border-2 border-black/10 shadow-inner">

                    {/* Scale and Text */}
                    <div className="absolute w-full h-full top-0 left-0">
                        {/* Text labels for the scale */}
                        <span className="absolute text-sm" style={{ top: '55%', left: '15%', transform: 'rotate(-45deg)' }}>BAJO</span>
                        <span className="absolute text-sm" style={{ top: '25%', left: '42%' }}>MEDIO</span>
                        <span className="absolute text-sm text-red-600 font-bold" style={{ top: '55%', right: '15%', transform: 'rotate(45deg)' }}>ALTO</span>
                    </div>

                    {/* Ticks */}
                    <div className="absolute w-full h-full top-0 left-0">
                        {Array.from({ length: 25 }).map((_, i) => {
                            const angle = -60 + (i * 4.8);
                            const isMajorTick = i % 5 === 0;
                            return (
                                <div
                                    key={i}
                                    className="absolute w-px h-full left-1/2"
                                    style={{ transform: `rotate(${angle}deg)`, transformOrigin: 'bottom center' }}
                                >
                                    <div className={`w-px mx-auto ${isMajorTick ? 'h-4 bg-black' : 'h-2 bg-gray-500'}`}></div>
                                </div>
                            );
                        })}
                    </div>

                     {/* Red arc */}
                    <div
                        className="absolute w-[200%] h-[200%] top-[calc(50%-1px)] left-[-50%] rounded-full border-t-[30px] border-r-[30px] border-red-500/70"
                        style={{
                            clipPath: 'polygon(50% 0%, 100% 0%, 100% 50%, 50% 50%)',
                            transform: 'rotate(35deg)',
                            transformOrigin: '50% 50%',
                            borderColor: 'rgba(239, 68, 68, 0.5)'
                        }}
                    ></div>


                    {/* Multimetro Text */}
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 translate-y-2 text-center z-10">
                        <span className="text-4xl font-bold tracking-widest text-black/80" style={{fontFamily: 'sans-serif'}}>Multómetro</span>
                        <p className="text-sm text-gray-700">Tasa de Éxito</p>
                    </div>

                    {/* Needle */}
                    <div
                        className="absolute bottom-0 left-1/2 w-1 h-1/2 transition-transform duration-[2000ms] ease-out z-20"
                        style={{ transform: `translateX(-50%) rotate(${needleRotation}deg)`, transformOrigin: 'bottom center' }}
                    >
                        <div className="w-0.5 h-[95%] bg-black shadow-lg"></div>
                         <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-gray-700 border-2 border-gray-400"></div>
                    </div>

                     {/* Needle base */}
                    <div className="absolute bottom-[-15px] left-1/2 -translate-x-1/2 w-20 h-10 bg-vumeter-case rounded-t-full border-t-2 border-black/20 z-20"></div>

                    {/* Success light */}
                    <div className="absolute bottom-8 right-10 flex flex-col items-center z-10">
                        <div className="w-5 h-5 bg-green-500 rounded-full shadow-lg animate-pulse-green border-2 border-white/50"></div>
                        <span className="text-xs font-bold text-green-800 mt-1 uppercase">Éxito</span>
                    </div>
                </div>
            </div>
        </div>
    );
};
